import { IEnvironment } from '@core/models';

export const environment: IEnvironment = {
  name: 'stage',
  production: false,
  domain: 'stage-myhivve.com',
  version: process.env['NG_APP_VERSION'] + '-stage',
  logGroupName: '/my/app/client',
  logStreamName: 'frontend',
  gstConfig: {
    trackingIds: [process.env['NG_APP_GST_TRACKING_ID']],
    anonymizeIp: true
  },
  awsCognitoConfig: {
    cognito: {
      Auth: {
        region: 'eu-west-1',
        userPoolId: 'eu-west-1_KznkDrDFw',
        userPoolWebClientId: '7pgoa1h47rcul08udtcf8iep5o',
        authenticationFlowType: 'USER_PASSWORD_AUTH',
        oauth: {
          domain: 'stage-myhivve.com',
          customDomain: 'auth.stage-myhivve.com',
          scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
          redirectSignIn: 'https://stage-myhivve.com/auth/callback',
          redirectSignOut: 'https://stage-myhivve.com',
          responseType: 'code'
        }
      }
    }
  },
  contact: {
    supportEmail: 'support@stage-hivveimpact.com',
    companyEmail: 'hello@stage-hivveimpact.com'
  },
  appAccessCode: process.env['NG_APP_APP_ACCESS_CODE'],
  unsplashConfig: {
    access: process.env['NG_APP_UNSPLASH_ACCESS_KEY']
  }
};
